import React, { useEffect } from "react";
import { useI18n } from "../i18n/i18n";
import { formatPromptDateLabel } from "../utils/formatDateLabels";

export default function DatePromptModal({
    isOpen,
    type,
    targetName,
    targetDate,
    todayDate,
    selectedChoice,
    onChoiceChange,
    onConfirm,
    onClose,
}) {
    const { t, locale } = useI18n();

    useEffect(() => {
        if (!isOpen) return;
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                onClose();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div
            className="datePromptModalOverlay"
            role="dialog"
            aria-modal="true"
            aria-labelledby="datePromptModalTitle"
            onClick={onClose}
        >
            <div
                className="datePromptModalContent"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="datePromptModalHeader">
                    <h3 id="datePromptModalTitle" className="datePromptModalTitle">
                        {t("home.datePromptTitle")}
                    </h3>
                    <button
                        type="button"
                        className="datePromptModalClose"
                        onClick={onClose}
                        aria-label={t("home.datePromptCancel")}
                    >
                        &times;
                    </button>
                </div>

                <p className="datePromptModalQuestion">
                    {type === "exercise"
                        ? t("home.datePromptExerciseQuestion", { name: targetName })
                        : t("home.datePromptMuscleQuestion", { group: targetName })}
                </p>

                <div className="datePromptRadioGroup" role="radiogroup" aria-label={t("home.datePromptTitle")}>
                    <label className={`datePromptRadioOption ${selectedChoice === "today" ? "isSelected" : ""}`}>
                        <input
                            type="radio"
                            name="datePromptChoice"
                            value="today"
                            checked={selectedChoice === "today"}
                            onChange={() => onChoiceChange("today")}
                        />
                        <div className="datePromptRadioLabelBlock">
                            <span className="datePromptRadioPrimary">
                                {t("home.datePromptToday")}
                            </span>
                            <span className="datePromptRadioSubtext">
                                {formatPromptDateLabel(todayDate, locale)}
                            </span>
                        </div>
                    </label>

                    <label className={`datePromptRadioOption ${selectedChoice === "targetDate" ? "isSelected" : ""}`}>
                        <input
                            type="radio"
                            name="datePromptChoice"
                            value="targetDate"
                            checked={selectedChoice === "targetDate"}
                            onChange={() => onChoiceChange("targetDate")}
                        />
                        <div className="datePromptRadioLabelBlock">
                            <span className="datePromptRadioPrimary">
                                {t("home.datePromptSelectedDate")}
                            </span>
                            <span className="datePromptRadioSubtext">
                                {formatPromptDateLabel(targetDate, locale)}
                            </span>
                        </div>
                    </label>
                </div>

                <div className="datePromptModalActions">
                    <button
                        type="button"
                        className="appButton appButton--secondary datePromptCancelButton"
                        onClick={onClose}
                    >
                        {t("home.datePromptCancel")}
                    </button>
                    <button
                        type="button"
                        className="appButton datePromptConfirmButton"
                        onClick={onConfirm}
                    >
                        {t("home.datePromptConfirm")}
                    </button>
                </div>
            </div>
        </div>
    );
}
